import { render, staticRenderFns } from "./confirm-dialog.vue?vue&type=template&id=197da311"
import script from "./confirm-dialog.vue?vue&type=script&lang=js"
export * from "./confirm-dialog.vue?vue&type=script&lang=js"
import style0 from "./confirm-dialog.vue?vue&type=style&index=0&id=197da311&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports